export enum MessageTranslKey {
    ALL_CURRENT_STATES = "message:allCurrentStates",
    ANNOTATION = "message:annotation",
    ATTACHMENTS_TAB = "message:attachmentsTab",
    CREATE_SINCE = "message:createSince",
    CREATE_TIME = "message:createTime",
    CREATE_TO = "message:createTo",
    CURRENT_STATE = "message:currentState",
    ERROR_COUNT = "message:errorCount",
    ID = "message:id",
    ISDS_MESSAGE_OVERVIEW = "message:isdsMessageOverview",
    MESSAGE_INFO_TAB = "message:messageInfoTab",
    NEXT_TRY_AFTER = "message:nextTryAfter",
    PRIORITY = "message:priority",
    RECIPIENT = "message:recipient",
    STATE_HISTORY_TAB = "message:stateHistoryTab",
}
